import { render, staticRenderFns } from "./appIndex.vue?vue&type=template&id=5410a0c9&scoped=true&"
import script from "./appIndex.vue?vue&type=script&lang=js&"
export * from "./appIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410a0c9",
  null
  
)

export default component.exports